import { render, staticRenderFns } from "./Facets.vue?vue&type=template&id=df2f7012"
import script from "./Facets.vue?vue&type=script&setup=true&lang=js"
export * from "./Facets.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Facets.vue?vue&type=style&index=0&id=df2f7012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports